import React from "react";
import { Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import { Form, Input, Checkbox, Button } from "antd";
import BgLeft from "../../../assets/images/bg-left.png";
import BgRight from "../../../assets/images/bg-right.png";
import { ReactComponent as PasswordHide } from "../../../assets/icons/password-hidden.svg";
import { ReactComponent as PasswordShow } from "../../../assets/icons/password-show.svg";
import Validator from "../../../utils/formValidator";
import { GALoginClickToSignUp, GALoginClickConfirm, GALoginClickToService, GALoginClickToPrivacy } from "../../../ga/login";
import { GAForgotPasswordBtnClick } from "../../../ga/forgotPassword";
import "../../../assets/login.scss";
import Cookies from "js-cookie";

const LoginRender = ({ handleForgotPasswordModalVisible, loginLoading, handleRequestLogin, urlSearch }) => {
  const { t } = useTranslation(["loginAndSignUp", "common"]);

  /**
   * 自定义密码显示和隐藏icon
   * @param {*} visible
   */
  const passWordIconRender = visible => (visible ? <PasswordShow /> : <PasswordHide />);

  const [form] = Form.useForm();
  return (
    <div className="login-page-cont position-relative mb-5 pb-0 pb-md-5">
      <div className="login-page-bg position-absolute top-0 left-0 w-100 d-flex justify-content-between">
        <img className="d-lg-block d-none" src={BgLeft} alt="bg" />
        <img className="d-lg-block d-none" src={BgRight} alt="bg" />
      </div>
      <div className="container mx-auto d-flex flex-column align-items-center justify-content-center">
        <h2 className="fw-bold mb-3">{t("common:login")}</h2>
        <p className="mb-2 pb-4 text-center">
          {t("signUpTips")}
          <Link className="ms-2" to={`/signUp${urlSearch}`} onClick={GALoginClickToSignUp}>
            {" "}
            {t("common:signUp")}
          </Link>
        </p>
        <Form
          form={form}
          name="loginForm"
          className="w-100"
          onFinish={handleRequestLogin}
          initialValues={{
            remember: Cookies.get("_u_info") ? true : false,
            email: Cookies.get("_u_info") ? JSON.parse(Cookies.get("_u_info")).e : "",
            password: Cookies.get("_u_info") ? JSON.parse(Cookies.get("_u_info")).p : "",
          }}
          validateTrigger="onBlur"
        >
          <Form.Item
            name="email"
            label=""
            rules={[
              {
                required: true,
                formName: "login",
                validator: Validator.emailValidator,
              },
            ]}
          >
            <Input placeholder={t("common:email")} />
          </Form.Item>
          <Form.Item
            name="password"
            label=""
            rules={[
              {
                required: true,
                formName: "login",
                validator: Validator.passwordValidator,
              },
            ]}
            className="mb-3"
          >
            <Input.Password placeholder={t("common:password")} iconRender={passWordIconRender} />
          </Form.Item>
          <Form.Item name="remember" label="" valuePropName="checked" className="mb-3">
            <Checkbox className="small">{t("rememberMe")}</Checkbox>
          </Form.Item>
          <Form.Item className="mb-3">
            <Button
              className="w-100 fw-bolder"
              type="primary"
              htmlType="submit"
              size="large"
              loading={loginLoading}
              onClick={() => {
                GALoginClickConfirm(form.getFieldValue("remember") ? "yes" : "");
              }}
            >
              {t("common:login")}
            </Button>
          </Form.Item>
        </Form>
        <a
          className="text-primary"
          style={{ marginBottom: 52 }}
          onClick={() => {
            handleForgotPasswordModalVisible(true);
            GAForgotPasswordBtnClick("login");
          }}
        >
          {t("forgotPassword")}
        </a>
        <p className="mb-4 text-center small" style={{ color: "rgba(27, 27, 27, 0.5)" }}>
          <Trans i18nKey="loginAndSignUp:loginPrivacyTips">
            Text
            <Link className="text-primary" to="/services-policy" onClick={GALoginClickToService} target="_blank">
              Link
            </Link>
            Text
            <Link className="text-primary" to="/privacy-policy" onClick={GALoginClickToPrivacy} target="_blank">
              Link
            </Link>
          </Trans>
        </p>
      </div>
    </div>
  );
};

export default LoginRender;
